import React from "react";

const CommentIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#FFE6E6" />
        <path
          d="M6.1665 12H17.8332M17.8332 12L11.9998 6.16666M17.8332 12L11.9998 17.8333"
          stroke="#0D0D0D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default CommentIcon;
